import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  dayDate
  sequenceId
`

export const getDaysQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getDays(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getDays(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}






